{
    "account": "Учётная запись",
    "add_bookmark": "Добавить сообщение в закладки",
    "add_date": "Добавить дату",
    "ago": "{{duration}} тому назад",
    "api_key": "Ключ API",
    "are_you_sure": "Вы уверены?",
    "ask_delete_message": "Удалить это сообщение?",
    "audio_not_ready": "Аудио еще не готово.",
    "bookmark_added": "Сообщение добавлено в закладки.",
    "bookmark_removed": "Сообщение удалено из закладок.",
    "bookmarks": "закладки",
    "cancel_write": "Вы действительно хотите отменить отправку нового сообщения?",
    "cancel": "Отменить",
    "changed_group_name": "изменил название группы",
    "confirm_password_placeholder": "подтвердите пароль",
    "connect": "Подключение",
    "create_a_group": "Создать группу",
    "create_the_group": "Создать эту группу",
    "daily": "Каждодневно",
    "default_group": "Группа по умолчанию",
    "delete": "Удалить",
    "destroy_account_explain": "Как только вы удалите свою учётную запись, возврата не будет. Имейте в виду.",
    "destroy_account": "Удалить свой аккаунт",
    "edit": "Редактировать",
    "email_input": "Напишите свой адрес электронной почты здесь",
    "email": "Электронная почта",
    "empty_message": "Сообщение пустое и не может быть отправлено.",
    "error_new_message": "При отправке вашего сообщения произошла ошибка.",
    "error_upload": "Во время загрузки произошла ошибка",
    "error": "Произошла ошибка",
    "forgot_password": "Забыли свой пароль?",
    "group_left": "Вы покинули группу.",
    "group_share_choice": "Какой группе вы хотите отправить это сообщение?",
    "groups": "Группы",
    "group_updated": "Группа была обновлена.",
    "has_commented_on": "прокомментировал",
    "has_joined": "присоединился",
    "has_left": "ушел",
    "has_posted_in": "разместил в",
    "hourly": "Каждый час",
    "Invalid login/password": "Неверный логин и/или пароль",
    "invitation_link": "Пригласительная ссылка",
    "invitation_welcome": "Добро пожаловать на Zusam! Пожалуйста, зарегистрируйтесь, прежде чем присоединиться к группе.",
    "in": "в",
    "just_now": "Прямо сейчас",
    "lang": "язык",
    "login_input": "Выберите имя пользователя",
    "login_placeholder": "электронная почта",
    "login": "Войти",
    "logout": "Выйти",
    "mark_all_as_read": "отметьте все как прочитанное",
    "monthly": "Каждый месяц",
    "multiple_photos_upload": "Произошла ошибка. Попробуйте загружать изображения по одному (это может произойти в некоторых браузерах)",
    "name_input": "Выбрать имя",
    "name": "Имя",
    "new_password_placeholder": "новый пароль",
    "next_coms": "Посмотреть следующие комментарии",
    "none": "Ничего",
    "notification_emails_stopped": "Уведомления по электронной почте остановлены!",
    "notification_emails": "Уведомления по электронной почте",
    "notifications": "уведомления",
    "parent_message": "Исходное сообщение",
    "password_input": "Введите новый пароль здесь",
    "password_placeholder": "пароль",
    "password_reset_mail_sent": "Проверьте ваш электронный ящик на письмо.",
    "passwords_dont_match": "Пароли не совпадают",
    "password": "Пароль",
    "previous_coms": "Посмотреть предыдущие комментарии",
    "public_link": "общедоступная ссылка",
    "publish_in_group": "опубликовать в группе",
    "quit_group": "Покинуть группу",
    "remove_bookmark": "Удалить сообщение из закладки",
    "replies_one": "{{count}} ответ",
    "replies_other": "{{count}} ответов",
    "reply": "ответить",
    "reset_api_key": "Сбросьте ключ API (вы будете отключены)",
    "reset_invitation_link": "Сбросить ссылку на приглашение",
    "reset_password_title": "Сбросить пароль",
    "save_changes": "Сохранить изменения",
    "search_in_group": "поиск в этой группе",
    "search_without_result": "Ваш поиск не выявил ни одного сообщения.",
    "settings_updated": "Ваши настройки были обновлены",
    "settings": "Настройки",
    "share_message": "поделиться сообщением",
    "signup": "Регистрация",
    "submit": "Отправить",
    "text_placeholder": "Напишите свое сообщение здесь",
    "the_message_from": "сообщение от",
    "title_placeholder": "Заголовок вашего сообщения (опционально)",
    "to": "к",
    "upload_audio": "Добавить аудиофайл.",
    "upload_image": "Добавить фотографии",
    "upload_music": "Добавить музыку",
    "upload_pdf": "Добавить PDF-файл",
    "upload_video": "Добавить видео",
    "User not found": "Пользователь не найден",
    "users": "пользователи",
    "video_not_ready": "Видео еще не готово.",
    "weekly": "Каждую неделю"
}
